import Papa from 'papaparse'
import {
  CONTRACTOR_TYPE_DE_OPTIONS,
  CONTRACTOR_TYPE_DE_TO_LABEL,
  CONTRACTOR_TYPE_OPTIONS,
  CONTRACTOR_TYPE_TO_LABEL,
  PREDEFINED_COLORS,
} from '../../constants'

/**
 * Check if the user is on a small screen.
 * @returns {Boolean}
 */
export const isSmallScreen = () => window.innerWidth <= 786

export const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(
  navigator.userAgent,
)
/**
 * Trigger a download in the browser.
 * Adapted from https://ourcodeworld.com/articles/read/189/how-to-create-a-file-and-generate-a-download-with-javascript-in-the-browser-without-a-server
 */
export const downloadStringAsFile = function(
  content,
  filename,
  mimeType = 'text/plain',
) {
  var element = document.createElement('a')
  element.setAttribute(
    'href',
    `data:${mimeType};charset=utf-8,` + encodeURIComponent(content),
  )
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

/**
 * Receives array of objects and converts it to CSV and starts downloading
 * @param {Arrya} data Array of rows
 * @param {String} filename Name of the file
 */
export const downloadJsonAsCsv = (data, filename) => {
  const columns = Object.keys(data[0])
  const dataString = data.reduce((acc, row) => {
    acc += Object.values(row).join(',') + '\n'
    return acc
  }, columns.join(',') + '\n')
  return downloadStringAsFile(dataString, `${filename}.csv`)
}

/**
 * Parse a csv file object and return the data as an object.
 * @param {File} file
 * @returns {Promise<object>}
 */
export const parseCSV = function(file) {
  return new Promise(function(resolve, reject) {
    Papa.parse(file, {
      header: true,
      // Specifying this messes up line numbers
      //skipEmptyLines: 'greedy',
      complete: resolve,
      error: reject,
    })
  })
}

/**
 * Read a file's content
 * @param {File}
 * @returns {Promise<string>}
 */
export const readFile = function(file) {
  return new Promise(function(resolve, reject) {
    var reader = new FileReader()
    reader.onload = function(e) {
      resolve(reader.result)
    }
    reader.onerror = reject
    reader.readAsText(file)
  })
}

export class CSVError {
  constructor(message, lineNumber) {
    this.message = message

    if (lineNumber === undefined)
      throw new Error(
        'Error does not have a line number. ' +
          'Specify null if this is intentional',
      )
    this.lineNumber = lineNumber
  }
}

let existingScripts = {}
export const loadScript = function(url) {
  if (existingScripts[url]) {
    return existingScripts[url]
  }
  return new Promise((res, rej) => {
    var script = document.createElement('script')
    script.src = url
    script.type = 'text/javascript'
    script.onload = onload => {
      existingScripts[url] = new Promise(res => res(onload))
      res(onload)
    }
    script.onerror = rej
    document.head.appendChild(script)
  })
}

export const loadCSS = function(url) {
  return new Promise((res, rej) => {
    var link = document.createElement('link')
    link.href = url
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.onload = res
    link.onerror = rej
    document.head.appendChild(link)
  })
}

/**
 * Pick random color from the constant of predefined colors
 * @returns {string}
 */
export const generateRandomColor = () =>
  PREDEFINED_COLORS[Math.floor(Math.random() * PREDEFINED_COLORS.length)].value

/**
 * parse csv data to object of flyercodes
 * @returns {object}
 */

export const processCsvFile = async file => {
  if (!file) return
  let fileContent = await readFile(file)
  // Trim to allow for empty spaces at the end
  fileContent = fileContent.trimRight()
  const csvData = await parseCSV(fileContent)
  if (csvData.errors && csvData.errors.length) {
    csvData.errors.map(eObj => {
      let error = new CSVError(eObj.message, eObj.row + 2)
      return error
    })
  }

  return csvData
}

export const isImageURL = url => {
  // Regular expression to match common image file extensions
  var imageExtensions = /\.(jpg|jpeg|png|gif|bmp|svg)/i

  return imageExtensions.test(url)
}

export const getContractorTypesLabelsByCountryCode = country => {
  switch (country) {
    case 'ES':
      return CONTRACTOR_TYPE_TO_LABEL
    case 'DE':
      return CONTRACTOR_TYPE_DE_TO_LABEL
    default:
      return null
  }
}

export const getContractorTypesOptionsByCountryCode = country => {
  switch (country) {
    case 'ES':
      return CONTRACTOR_TYPE_OPTIONS
    case 'DE':
      return CONTRACTOR_TYPE_DE_OPTIONS
    default:
      return null
  }
}
